import { tradeInRoutes } from '@makemydeal/dr-activities-tradein';

export const getTargetPath = (args: unknown[]): string | undefined => {
    const target = args[0];
    if (typeof target === 'string') {
        return target;
    }
    if (target && typeof target === 'object' && 'pathname' in target) {
        return (target as { pathname?: string }).pathname;
    }
    return undefined;
};

// Strips any query string so route matching works on the pathname alone
// (navigationMiddleware appends ?dealXgId=... to the intent before pushing).
export const getPathname = (route?: string): string | undefined => (route ? route.split('?')[0] : undefined);

export const isTradeInRoute = (path?: string): boolean => {
    const pathname = getPathname(path);
    if (!pathname) {
        return false;
    }
    return tradeInRoutes.some((route) => pathname === route || pathname.startsWith(`${route}/`));
};
